import React from 'react';
import { Link } from 'react-router-dom';

import logoHorizontal from '../assets/no BG New Cura Logo.png';
import { PixelMountains } from './ui/magic/PixelMountains';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: 'Features', href: '/#features' },
      { label: 'Enterprise API', href: '/enterprise-api' },
      { label: 'Cura Scan', href: '/scan' },
      { label: 'For Seniors', href: '/seniors' },
      { label: 'For Caregivers', href: '/caregivers' },
    ],
    company: [
      { label: 'About Us', href: '/about' },
      { label: 'Careers', href: '/careers' },
      { label: 'Blog', href: '/blog' },
      { label: 'Press', href: '/press' },
      { label: 'Pitch Deck', href: '/pitch' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Cookie Policy', href: '/cookie-policy' },
      { label: 'Acceptable Use', href: '/acceptable-use' },
      { label: 'Trust Center', href: 'https://trust.mycura.org' },
    ],
    support: [
      { label: 'Help Center', href: 'https://support.mycura.org' },
      { label: 'Contact Us', href: 'mailto:founders@mycura.org' },
      { label: 'System Status', href: 'https://status.mycura.org' },
    ]
  };



  return (
    <footer className="bg-white text-slate-600 pt-16 border-t border-gray-100" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-6">

          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <Link to="/" className="inline-block" aria-label="Cura homepage">
              <img
                src={logoHorizontal}
                alt="Cura - AI-powered medical assistant"
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
              AI-powered medical assistant delivering instant health guidance for seniors and caregivers,
              in partnership with nonprofits and community organizations.
              Trusted symptom assessment, telehealth support, and compassionate care, all HIPAA-compliant.
            </p>

          </div>

          {/* Links Columns */}
          <nav aria-label="Product navigation">
            <h3 className="text-slate-900 font-semibold mb-6">Product</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="hover:text-[#003b82] transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company navigation">
            <h3 className="text-slate-900 font-semibold mb-6">Company</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="hover:text-[#003b82] transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Support links">
            <h3 className="text-slate-900 font-semibold mb-6">Support</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : undefined}
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="hover:text-[#003b82] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Legal links">
            <h3 className="text-slate-900 font-semibold mb-6">Legal</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith('http') ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-[#003b82] transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.href} className="hover:text-[#003b82] transition-colors">
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>

      </div>

      {/* Closing horizon, rising right up to the footer content */}
      <PixelMountains
        className="h-[150px] md:h-[190px]
          [mask-image:linear-gradient(to_bottom,#000_78%,transparent_100%)]
          [-webkit-mask-image:linear-gradient(to_bottom,#000_78%,transparent_100%)]"
      />

      {/* Bottom Bar: reads as ground under the range, no seam */}
      <div className="bg-gradient-to-b from-white to-[#EEF2F9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-slate-500">
          <span>&copy; {currentYear} Cura, A brand of Onex Technology. All rights reserved.</span>

          <a
            href="https://status.mycura.org"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-[#003b82] transition-colors"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            All Systems Operational
          </a>
        </div>
      </div>
    </footer >
  );
};

export default Footer; 